import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  experiences: (params) => axios.get(`${API}/experiences`, { params }).then((r) => r.data),
  experience: (slug) => axios.get(`${API}/experiences/${slug}`).then((r) => r.data),
  destinations: () => axios.get(`${API}/destinations`).then((r) => r.data),
  addons: () => axios.get(`${API}/addons`).then((r) => r.data),
  stories: (params) => axios.get(`${API}/stories`, { params }).then((r) => r.data),
  stays: () => axios.get(`${API}/stays`).then((r) => r.data),
  createInquiry: (data) => axios.post(`${API}/inquiries`, data).then((r) => r.data),
};
